// extracted by mini-css-extract-plugin
export default {"self":"PrimaryButton_self__JWZVm"};